<script>
  import { userInfo } from '@dopry/svelte-auth0';
  import DashboardOrderItem from './DashboardOrderItem.svelte';
  import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
  } from 'sveltestrap';
  import { money } from '../util';
  export let order;
  const approveStatusLabel =
      order?.approved == undefined || order?.approved
        ? 'Approved'
        : 'Unapproved',
    orderStatusLabel = order?.shipped
      ? 'Shipped'
      : order?.approved
      ? 'Approved'
      : order?.approved != undefined && !order?.approved
      ? 'Unapproved'
      : 'Ordered';
  let open = false;
  const toggle = () => (open = !open);
</script>

<div>
  <span class="lineItem">
    {$userInfo?.email == order?.orderEmail ? 'ordered' : 'approved'} on {order?.orderDate}
    for store {order?.storeName} ({order?.marketName}) w/
    {order?.orderItems.length} items @ {money.format(order?.orderTotal)}
  </span>
  <span class="lineItemAction">
    <Button
      color={orderStatusLabel == 'Unapproved' ? 'danger' : 'primary'}
      size="sm"
      block
      on:click={toggle}>{orderStatusLabel}</Button
    >
  </span>
</div>
<Modal isOpen={open} {toggle}>
  <ModalHeader {toggle}>Order Summary</ModalHeader>
  <ModalBody>
    <h5>Ordered:</h5>
    <div>
      {order?.orderUser} ({order?.orderEmail}) placed order on {order?.orderDate}
    </div>
    <div>{order?.storeName} ({order?.marketName})</div>
    <br />
    {#each order.orderItems as item}<DashboardOrderItem {item} />{/each}
    <br />
    Ordered Total: {money.format(order?.orderTotal)}
    <br /><br />
    <h5>{approveStatusLabel}</h5>
    {#if order?.approved == undefined}This order is pending approval, please
      check back later.{:else}
      <div>
        {order?.approveUser || 'Order Assistant'} ({order?.approveEmail || 'OA'})
        {approveStatusLabel.toLowerCase()} order on {order?.approveDate}
      </div>
      {#if order?.comments}<div>{order?.comments}</div>{/if}
      <br />
      {#if !order.approveItems}
        The original cart items were unchanged.
      {:else}
        {#each order.approveItems as item}<DashboardOrderItem {item} />{/each}
        <br />
        Approved Total: {money.format(order?.approvalTotal)}
      {/if}
    {/if}
    <br /><br />
    <h5>Shipped:</h5>
    {#if order?.approved !== undefined && !order?.approved}
      This order will not be shipped since it was unapproved.
    {:else if order?.shipped == undefined}
      This order is pending shipment, please check back later.
    {:else}
      Your order was shipped and can be reviewed online
      <a href={order?.invoiceURL} target="_blank">here</a>.
    {/if}
  </ModalBody>
  <ModalFooter
    ><Button color="danger" on:click={toggle}>Close</Button></ModalFooter
  >
</Modal>

<style>
  .lineItem {
    display: inline-block;
    width: 80%;
  }
  .lineItemAction {
    display: inline-block;
    width: 125px;
    margin: 1px;
  }
</style>
